import gql from 'graphql-tag';

const GET_FILTERED_HASHED_EMAIL_LIST_WITH_COUNT = gql`
  query getFilteredHashedEmailListWithCount($orgId: String, $searchTerm: String) {
    getFilteredHashedEmailListWithCount(orgId: $orgId, searchTerm: $searchTerm)
  }
`;

export default GET_FILTERED_HASHED_EMAIL_LIST_WITH_COUNT;
